<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">环卫车辆专用智能运行监管仪</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 76%" class="oneBodyImgCls" src="../../assets/images/vtcwm101_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">环卫车辆专用智能运行监管仪</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          本产品集全球卫星定位技术、数据/短信以及数据通讯无线数字移动通讯和GIS地理信息等先进技术于一体，具有全球卫星定位、网上轨迹查询、兼容原车防盗器、智能防盗报警功能。该产品严格按照工业产品生产制造要求进行生产，各项性能指标均处于国内领先水平。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">整机：90mm(长)*89mm(宽)*30mm(高)(带安装固定孔)</div>
      <div class="center_two_e">壳体：90mm(长)*73mm(宽)*30mm(高)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        车辆
      </div>

      <div class="center_two_d">功能</div>
    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left_double">监听<br/>功能</div>
        <div class="three_body_left_right">服务器发指令至终端设备，它将回拨您设置的号码并按接听键可以监听车内动静；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">智能<br/>报警</div>
        <div class="three_body_right_right" style="text-align: right">打劫报警、主电源掉电报警、超速报警、越界报警、移位报警；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">自备<br/>电源</div>
        <div class="three_body_left_right">设备内置有460mAH锂电池，在充满电的情况下，断外电可工作5分钟，上传一些必要的信息；</div>
      </div>

      <div class="center_three_body_right" style="margin-bottom: 48px">
        <div class="three_body_right_left_double">远程<br/>设置</div>
        <div class="three_body_right_right">远程参数设置功能，设备可远程进行参数调整，包括时间、间隔、IP地址、端口号等等。</div>
      </div>

    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../../assets/images/fk4151_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../../assets/css/detailCommonSecond";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 367px;

    .oneBodyImgCls {
      width: 100%;
      height: 367px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 425px;

    .oneBodyImgCls {
      width: 100%;
      height: 425px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 551px;

    .oneBodyImgCls {
      width: 100%;
      height: 551px;
    }
  }
}

.center_one_body_current {
  display: flex;
  flex-direction: row-reverse;

  .oneBodyImgCls {
  }
}

</style>